import { DateTime } from "luxon";
import type { SimulatorScreenShotsDto, SimulatorScreenShots } from "Models";

/**
 * Maps a DTO with ISO date strings into a strongly-typed screenshot model
 * with Luxon DateTime instances.
 */
export function mapScreenshotDto(
  raw: SimulatorScreenShotsDto,
): SimulatorScreenShots {
  return {
    ...raw,
    captureTimeUtc: DateTime.fromISO(raw.captureTimeUtc, { setZone: true }),
    receivedTimeUtc: DateTime.fromISO(raw.receivedTimeUtc, { setZone: true }),
  };
}
